var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUserSwitch = function SvgIconUserSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.118 2.42a10 10 0 0 1 12.88 9.417l.17-.17a1 1 0 0 1 1.414 1.415l-1.865 1.865a.997.997 0 0 1-1.434 0l-1.865-1.865a1 1 0 0 1 1.414-1.414l.166.166A8 8 0 0 0 5.667 7.108a1 1 0 1 1-1.584-1.222A10 10 0 0 1 9.118 2.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 14.714a4.75 4.75 0 1 1 6.5 0 7.75 7.75 0 0 1 2.935 2.365q.075-.093.148-.187a1 1 0 1 1 1.584 1.222A10 10 0 0 1 2 12.163l-.169.17a1 1 0 0 1-1.414-1.415l1.875-1.875a.997.997 0 0 1 1.415 0l1.874 1.875a1 1 0 1 1-1.414 1.414l-.166-.166a8 8 0 0 0 1.813 4.913 7.75 7.75 0 0 1 2.935-2.365m.5-3.464A2.75 2.75 0 1 1 12.045 14h-.09a2.75 2.75 0 0 1-2.705-2.75m-1.969 7.215a8 8 0 0 0 9.438 0A5.75 5.75 0 0 0 12.051 16h-.101a5.75 5.75 0 0 0-4.669 2.465"
  }))));
};
export default SvgIconUserSwitch;